import { render } from "./DetailCardComp.vue?vue&type=template&id=99651c00"
import script from "./DetailCardComp.vue?vue&type=script&lang=js"
export * from "./DetailCardComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__